module.exports = __webpack_public_path__ + "static/media/Q3 - Long-term care.be6e38bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/Survey/images/Q3 - Long-term care.png
// module id = 599
// module chunks = 0